import React, { FC, useContext } from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { EnterpriseActions } from './EnterpriseActions';
import { EnterpriseContext } from '../EnterpriseContext';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';

type Props = {
  isVisible: boolean;
};

export const EnterpriseActionSlider: FC<Props> = ({ isVisible }) => {
  const source = 'enterprise_page';
  const {
    enterpriseInfos: { raisonSociale, enterpriseId },
  } = useContext(EnterpriseContext);
  const { openRestrictedModal } = useRestrictedModal();
  return (
    <div className="sub-header__rails__tunnel">
      <div className="sub-header__rails__mask" />
      <div
        className={
          isVisible
            ? 'sub-header__rails__slider'
            : 'sub-header__rails__slider__move'
        }
      >
        <div className="add-entity-watcher__page-slider">
          <AddEntityWatcherButton
            queryParams={{ eid: enterpriseId, q: raisonSociale }}
            uniqueId={enterpriseId}
            restrict={() =>
              openRestrictedModal({ source: 'want_to_follow_lawyer' })
            }
            source={source}
          />
        </div>
        <EnterpriseActions source={source} name={raisonSociale} />
      </div>
    </div>
  );
};
